export enum ETipoRelacaoPessoa {
    Colaborador = 1,
    Cliente = 2,
    Fornecedor = 3,
    Transportadora = 4,
    Representante = 5
}
